import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'empresas-confianza/';

export interface EmpresaConfianza {
    id: number;
    nombre: string;
    rubro: string;
    descripcion: string;
    logo: string | null;
    logo_alt: string;
    orden: number;
    activo: boolean;
    created_at: string;
}

// 🔹 Obtener todas (admin)
export const fetchEmpresasConfianza = async (): Promise<EmpresaConfianza[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    });
};

// 🔹 Obtener una por ID
export const fetchEmpresaConfianza = async (id: number): Promise<EmpresaConfianza> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(`${API_URL}${id}/`);
        return response.data;
    });
};

// 🔹 Crear (IMPORTANTE: FormData por imagen)
export const createEmpresaConfianza = async (data: {
    nombre: string;
    rubro: string;
    descripcion: string;
    logo?: File | null;
    logo_alt?: string;
    orden?: number;
    activo?: boolean;
}): Promise<EmpresaConfianza> => {
    return handleRequestWithAuth(async () => {
        const formData = new FormData();

        formData.append('nombre', data.nombre);
        formData.append('rubro', data.rubro);
        formData.append('descripcion', data.descripcion);

        if (data.logo) formData.append('logo', data.logo);
        if (data.logo_alt) formData.append('logo_alt', data.logo_alt);
        if (data.orden !== undefined) formData.append('orden', String(data.orden));
        if (data.activo !== undefined) formData.append('activo', String(data.activo));

        const response = await axiosInstance.post(API_URL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    });
};

// 🔹 Actualizar
export const updateEmpresaConfianza = async (
    id: number,
    data: {
        nombre?: string;
        rubro?: string;
        descripcion?: string;
        logo?: File | null;
        logo_alt?: string;
        orden?: number;
        activo?: boolean;
    }
): Promise<EmpresaConfianza> => {
    return handleRequestWithAuth(async () => {
        const formData = new FormData();

        if (data.nombre) formData.append('nombre', data.nombre);
        if (data.rubro) formData.append('rubro', data.rubro);
        if (data.descripcion) formData.append('descripcion', data.descripcion);

        if (data.logo) formData.append('logo', data.logo);
        if (data.logo_alt !== undefined) formData.append('logo_alt', data.logo_alt);
        if (data.orden !== undefined) formData.append('orden', String(data.orden));
        if (data.activo !== undefined) formData.append('activo', String(data.activo));

        const response = await axiosInstance.patch(`${API_URL}${id}/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    });
};

// 🔹 Eliminar
export const deleteEmpresaConfianza = async (id: number): Promise<void> => {
    return handleRequestWithAuth(async () => {
        await axiosInstance.delete(`${API_URL}${id}/`);
    });
};